<template>
  <div class="albumContainer">
    <figure class="zero">
      <div class="darkborder"></div>
      <v-lazy-image :src="zero.image" :src-placeholder="zero.lqthumbnail" :alt="zero.name" />
    </figure>
    <div class="info">
      <h1>{{ current_item.title }}</h1>
      <p>{{ current_item.desc }}</p>
    </div>
    <template v-for="(i, index) of current_item.database.slice(1)">
      <figure :key="index">
        <div class="darkborder"></div>
        <v-lazy-image :src="i.image" :src-placeholder="i.lqthumbnail" :alt="i.name" />
      </figure>
    </template>
    <AlbumNav />
  </div>
</template>

<script>
import AlbumNav from "@/components/AlbumNav";
import VLazyImage from "v-lazy-image";
import { mapGetters } from "vuex";
export default {
  name: "Album",
  props: ["url_title"],
  components: {
    VLazyImage,
    AlbumNav
  },
  data() {
    return {
      zero: null
    };
  },
  computed: {
    ...mapGetters(["current_item"])
  },
  beforeMount: function() {
    this.zero = this.current_item.database[0];
  },
  created: function() {
    this.$store.dispatch("set_current_item", this.url_title);
  },
  mounted: function() {
    window.setTimeout(
      this.$el.scrollIntoView({
        block: "start"
      }),
      400
    );
  }
};
</script>

<style scoped lang="scss">
figure {
  width: 100%;
  border: solid 2px black;
  @include bigScreen {
    margin: 4rem;
    border: solid 4px black;
  }
  img {
    background: $darkSecondary;
    @include bigScreen {
      width: 100%;
    }
  }

  .darkborder {
    margin: 3px;
    position: absolute;
    width: calc(100% - 6px);
    height: calc(100% - 6px);
    /* background: red; */
    box-shadow: 0px 0px 0px 4px $darkPrimary;
  }
}

.albumContainer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: $darkPrimary;
  color: $lightPrimary;

  @include bigScreen {
    width: 75vw;
    margin: auto;
  }

  .info {
    margin: 2.5rem 0;
    padding: 0 0.5rem;
    width: 100%;
    @include bigScreen {
      margin: 3rem 2rem;
    }
    h1 {
      font-size: calc(16px + 2vw);
    }

    p {
      font-size: calc(14px + 1vw);
    }
  }
}
</style>
